<template>
   
        <v-layout row wrap>
            <v-flex offset-xs3 xs6>
                <v-card>                
                    <v-card-title>
                        <h2 class="grey--text text--darken-2">Login</h2>                                                
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>                                                                            
                        <v-layout row wrap>
                            <v-flex xs8>
                                <v-text-field
                                    autofocus
                                    name="email"
                                    label="E-Mail"
                                    id="email"                                    
                                    v-model="email"  
                                    :error="errors.has('email')"
                                    v-validate="'required|email'"
                                ></v-text-field>      
                                <small class="small red--text" v-show="errors.has('email')">{{ errors.first('email') }}</small>
                            </v-flex>
                            <v-flex xs8>
                                <v-text-field
                                    name="pass"
                                    label="Passwort"
                                    id="pass"
                                    v-model="pass"                                
                                    type="password"
                                    :error="errors.has('pass')"
                                    v-validate="'required|min:6'"
                                    v-on:keyup.enter="login()"                                  
                                ></v-text-field>
                                <small class="small red--text" v-show="errors.has('pass')">{{ errors.first('pass') }}</small>    
                                
                            </v-flex>
                        </v-layout>   
                    </v-card-text>
                    <v-card-actions> 
                        <v-flex xs4 offset-xs6>
                            <v-btn icon v-on:click="login()">
                                <v-icon x-large class="green--text">done</v-icon>
                            </v-btn>                        
                            <router-link to="/firmen" exact>
                                <v-btn icon>
                                    <v-icon x-large class="red--text">close</v-icon>
                                </v-btn>
                            </router-link>
                        </v-flex>
                    </v-card-actions>
                    
                </v-card>
            </v-flex>
        </v-layout>
         
</template>

<script>

import formHelper from '../formHelper.vue'

export default {
    inject:['$validator'],
    data() {
        return {                        
            pass:'',
            email:'',                          
        }
    },
    computed: {
        loading: function() {
            return this.$store.getters.loading
        },
       
  
    },
    
    methods: {
        
        login: function() {
            
            
            this.$store.commit('setMessagebar', false)
            this.$validator.validateAll().then((result) =>{
               if(!result) {
                   this.$store.commit('setMessagebar', true)
                   return
               }
            
                let data= {
                    email: this.email,
                    pass: this.pass
                }
                this.$store.dispatch('loginUser', data)
                    .then(response=> {
                        
                        this.$store.dispatch('setAuthenticatedUser')
                        .then(response=>{
                            this.$store.commit('setMessagebar', true)
                            this.$router.push('/dashboard')
                        }, error=>{
                            this.$store.commit('setMessagebar', true)
                            this.$router.push('/login')
                        })
                    }, error => {
                        this.$store.commit('setMessagebar', true)
                        this.$router.push('/login')
                })
            })
        }
    },
   
}
</script>

<style >

    
    
</style>


// WEBPACK FOOTER //
// login.vue?98118254